(() => {
  if (window.saleCountdownManager) {
    window.saleCountdownManager.init(document);
    return;
  }
  const instances = new Map();
  const init = (scope) => {
    scope.querySelectorAll('[data-sale-countdown]').forEach((section) => {
      if (instances.has(section)) return;
      const raw = (section.dataset.endDate || '').trim().replace(' ', 'T');
      const end = Date.parse(raw);
      const fields = Object.fromEntries(['days', 'hours', 'minutes', 'seconds'].map(unit => [unit, section.querySelector(`[data-${unit}]`)]));
      if (Object.values(fields).some(field => !field)) return;
      let interval;
      const render = () => {
        const remaining = Number.isFinite(end) ? Math.max(0, end - Date.now()) : 0;
        const values = {
          days: Math.floor(remaining / 86400000),
          hours: Math.floor(remaining / 3600000) % 24,
          minutes: Math.floor(remaining / 60000) % 60,
          seconds: Math.floor(remaining / 1000) % 60
        };
        Object.entries(values).forEach(([unit, value]) => { fields[unit].textContent = String(value).padStart(2, '0'); });
        if (remaining <= 0) clearInterval(interval);
        return remaining > 0;
      };
      if (render()) interval = setInterval(render, 1000);
      instances.set(section, () => { clearInterval(interval); instances.delete(section); });
    });
  };
  window.saleCountdownManager = { init };
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    [...instances.entries()].forEach(([section, destroy]) => { if (event.target.contains(section)) destroy(); });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  else init(document);
})();
